export default __webpack_public_path__ + "static/media/instagram.c6e512e6.png";